<div class="seller-events-list">
  @if (viewModel$ | async; as vm) {
    @switch (vm.state) {
      @case ("loading") {
        <div class="seller-events-list__grid seller-events-list__grid--skeleton">
          <p-skeleton height="280px" />
          <p-skeleton height="280px" />
          <p-skeleton height="280px" />
        </div>
      }
      @case ("empty") {
        <div class="seller-events-list__empty" role="status">
          <i class="pi pi-inbox seller-events-list__empty-icon" aria-hidden="true"></i>
          <p class="seller-events-list__empty-title">Nenhum evento encontrado</p>
          <p class="seller-events-list__empty-text">
            Aqui entram os eventos em que você é <strong>vendedor</strong>. Quando existirem, aparecerão nesta lista.
          </p>
        </div>
      }
      @case ("ready") {
        <div class="seller-events-list__grid">
          @for (event of vm.events; track event.id) {
            <app-event-card class="seller-events-list__card" [event]="event" />
          }
        </div>
      }
    }
  }
</div>
